//
//
//
//
//
//

export default {
  name: 'RuoYiDoc',
  data: function data() {
    return {
      url: 'http://doc.qjit.cn/docs/gfast/introduce'
    };
  },
  methods: {
    goto: function goto() {
      window.open(this.url);
    }
  }
};